import type { getSearchVariables } from '../getSearchVariables/getSearchVariables';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';
import { DATERANGES } from '#lib/websites/news/constants/dateranges.js';
import { NewsRoutes } from '#lib/websites/news/constants/routes.js';
import { page } from '$app/state';

export const isCategoryActive = ({
	path,
	searchCategory,
	variables,
}: {
	path: string;
	searchCategory: string;
	variables: ReturnType<typeof getSearchVariables>;
}) => {
	const category = variables['category'];

	// The HENI feed is not a category, so no category pill (including the
	// ShoutOuts default below) may render as active while it is on.
	if (variables['heni']) {
		return false;
	}

	if (
		path === GlobalRoutes.NewsHome &&
		searchCategory === ArticleSearchCategory.shoutouts
	) {
		return true;
	}

	return (
		variables.daterange === DATERANGES.ALL &&
		((!category &&
			Object.keys(variables).length === 1 &&
			searchCategory === ArticleSearchCategory.shoutouts &&
			page.route.id !== NewsRoutes.Data) ||
			(category?.toLowerCase() === searchCategory.toLowerCase() &&
				Object.keys(variables).length === 2))
	);
};
